import { FC } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Card, Typography } from '@altermaind/web/ui';
import { ProgressBar } from '@/_shared/components/ProgressBar';
import { Tooltip } from '@/_shared/components/Tooltip';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';
import { getDepartmentsCreditsCall } from '../../../state';

export const RecapDataDepartment: FC = () => {
  const t = useTranslations('departments.tabs.credits.progress');

  const { stats } = getDepartmentsCreditsCall.hook();

  const { genericResponsiveValue } = useResponsiveStyle();

  return (
    <Box mt='s'>
      <Card backgroundColor='primary'>
        <Box>
          <Box
            mb='xs'
            display='flex'
            justifyContent='space-between'
            flexDirection={genericResponsiveValue({
              breakPoints: { desktop: 'row' },
              defaultValue: 'column',
            })}
            alignItems={genericResponsiveValue({
              breakPoints: { desktop: 'center' },
              defaultValue: 'flex-start',
            })}
          >
            <Box display='flex' flexDirection='row' alignItems='center'>
              <Typography mr='xxxs' variant='p2'>
                {t('overall')}
              </Typography>
              <Tooltip>{t('overallTooltip')}</Tooltip>
            </Box>
            <Box>
              <Typography variant='p2/light'>
                {t('total')}{' '}
                <Typography fontWeight='500' as='span'>
                  {stats.used}
                </Typography>
              </Typography>
            </Box>
          </Box>
          <ProgressBar currentPercentage={Number(stats.utilizationPercentage)} />
          <Box display='flex' justifyContent='flex-end' mt='xxs'>
            <Typography variant='p2/light'>
              {t('media')}{' '}
              <Typography fontWeight='500' as='span'>
                {stats.avgUsedPerPerson}
              </Typography>
            </Typography>
          </Box>
        </Box>
      </Card>
    </Box>
  );
};
